import "@hotwired/turbo-rails"

import Rails from "@rails/ujs"
Rails.start()

import "trix"
import "@rails/actiontext"
import "./pet_carousel"

import { application } from "./controllers/application"
import AdoptionCertificateController from "./controllers/adoption_certificate_controller"

application.register("adoption-certificate", AdoptionCertificateController)

